import { createContext } from "react";

const DeviceCodeContext = createContext()
export default DeviceCodeContext